import { defineMessages } from 'react-intl';

export default defineMessages({
    
    cancelPaymenttext1:{
        id: 'billing.common.views.You are terminating automatic payments on this account.',
        defaultMessage: 'You are terminating automatic payments on this account. '
    },
    cancelPaymenttext2:{
        id: 'billing.common.views.please note that',
        defaultMessage: 'Please note that any previously billed invoice amounts will no longer be subject to automatic payments.'
    },
    paymentInProgress:{
        id: 'billing.common.views.Payment enrollment cannot be updated at this time',
        defaultMessage: 'Payment enrollment cannot be updated at this time due to a current payment in progress. We apologize for any inconvenience, please try again tomorrow.'
    },
    updateMessage:{
        id: 'billing.common.views.Automatic payments have been updated',
        defaultMessage: 'Automatic payments have been updated. A confirmation e-mail will be sent.'
    },
    setupMessage:{
        id: 'billing.common.views.Automatic payments have been set up',
        defaultMessage: 'Automatic payments have been set up. A confirmation e-mail will be sent.'
    },
    cancelMessage:{
        id: 'billing.common.views.Automatic payments have been Cancelled',
        defaultMessage: 'Automatic payments have been Cancelled. A confirmation e-mail will be sent.'
    }

    
    
});